import Vue from 'vue'
import 'iz-ds-neo-alt/dist/system/system.css'
import Vuetify from "vuetify"
import "vuetify/dist/vuetify.min.css"
import vi from '@/i18n/vi'
import en from '@/i18n/en'
import jp from '@/i18n/jp'
Vue.use(Vuetify)

const opts = {
  lang: {
    locales: { en, vi, jp },
    current: "vi",
  },
}

export default new Vuetify(opts)